import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { FaPen } from "react-icons/fa";
import { IoSearch } from "react-icons/io5";
import { MdOutlinePublishedWithChanges, MdOutlineRestorePage } from "react-icons/md";
import Pagination from "UpdatedComponents/Pagination";
import { Puff } from "react-loader-spinner";
import Badge from "UpdatedFeatures/Badge";
import StatusFilter from "UpdatedFeatures/StatusFilter";
import { getClientsPRO } from "UpdatedFeatures/api";
import ClientStatusModal from "./ClientStatusModal";
import UpdateClientModal from "./UpdateClientModal";
import CreateClientPROModal from "./CreateClientPROModal";

// const formatDate = (timestamp) => {
//     return new Date(timestamp).toLocaleDateString("fr-FR");
// };

const STATUS = {
    Pending: 0,
    Approved: 1,
    Active: 2,
    Disactivated: 3,
    All: null,
};

const statusOptions = [
    { id: STATUS.Pending, label: "En attente" },
    { id: STATUS.Approved, label: "Approuvé" },
    { id: STATUS.Active, label: "Actif " },
    { id: STATUS.Disactivated, label: "Désactivé" },
    { id: STATUS.All, label: "Tous" },
];


export default function ClientPROTable() {
    const [search, setSearch] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [isArchived, setIsArchived] = useState(false);
    const [page, setPage] = useState(1);
    const [perPage] = useState(10);
    const [selectedStatus, setSelectedStatus] = useState({ id: null, label: "Tous" });
    console.log(selectedStatus)
    const queryClient = useQueryClient();
    const [statusModalOpen, setStatusModalOpen] = useState(false);
    const [selectedClientForStatus, setSelectedClientForStatus] = useState(null);
    const [updateModalOpen, setUpdateModalOpen] = useState(false);
    const [selectedClientForUpdate, setSelectedClientForUpdate] = useState(null);
    const [createClientProModalOpen, setCreateClientProModalOpen] = useState(null);



    const { data: clients, isLoading, isError } = useQuery({
        queryKey: ["clients-pro", page, perPage, search, selectedStatus],
        queryFn: () => getClientsPRO({ page, perPage, search, status: selectedStatus.id }),
    });
    console.log(clients)
    console.log(page)
    const totalPages = Math.ceil((clients?.total || 0) / perPage);

    const handleSearchChange = (e) => setSearch(e.target.value);

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        setSearchTerm(search);
    };

    const handleNextPage = () => {
        setPage(prev => Math.min(prev + 1, totalPages));
    };

    const handlePrevPage = () => {
        setPage(prev => Math.max(prev - 1, 1));
    };

    const handleStatusChange = (client) => {
        setSelectedClientForStatus(client);
        setStatusModalOpen(true);
    };

    const handleEditClick = (client) => {
        setSelectedClientForUpdate(client);
        setUpdateModalOpen(true);
    };

    const handleUpdateSuccess = () => {
        queryClient.invalidateQueries(["clients-pro"]);
        setUpdateModalOpen(false);
        setSelectedClientForUpdate(null);
    };

    if (isError) {
        return (
            <div className="flex flex-col items-center justify-center min-h-[400px] gap-4">
                <span className="text-red-600 font-medium text-lg">
                    Une erreur s'est produite lors du chargement des données
                </span>
                <button
                    onClick={() => window.location.reload()}
                    className="px-4 py-2 bg-[#b269ae] text-white rounded-md hover:bg-[#9c58a3] transition-colors"
                >
                    Réessayer
                </button>
            </div>
        );
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 mt-12">
            <div className="sm:flex sm:items-center justify-between space-y-3">
                <div className="relative w-1/3">
                    <form onSubmit={handleSearchSubmit} className="flex items-center">
                        <input
                            type="text"
                            placeholder="Rechercher..."
                            value={search}
                            onChange={handleSearchChange}
                            className="block w-full p-3 pl-12 text-sm border border-[#b269ae] rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-300"
                        />
                        <button type="submit" className="absolute inset-y-0 left-0 flex items-center pl-3">
                            <IoSearch color="purple" />
                        </button>
                    </form>
                </div>

                <div className="flex flex-col md:flex-row md:items-center gap-3">
                    <StatusFilter
                        statusOptions={statusOptions}
                        selected={selectedStatus}
                        setSelected={setSelectedStatus}
                        STATUS={STATUS}
                    />
                    <div className="mt-4 sm:mt-0 flex items-center gap-3">
                        <button
                            onClick={() => setCreateClientProModalOpen(true)}
                            className="flex items-center justify-center px-3 py-2 rounded-full bg-[#b269ae] text-white font-semibold transition-all duration-300 hover:bg-yellow-400"
                        >
                            <span className="text-sm">+ Créer un Client PRO</span>
                        </button>
                    </div>
                </div>
            </div>

            <div className="mt-8 flow-root">
                <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                        <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                            {isLoading ?
                                (
                                    <div className="flex items-center justify-center min-h-[400px]">
                                        <Puff visible={true} height="80" width="80" color="#895a7c" ariaLabel="puff-loading" />
                                    </div>
                                ) :

                                !clients?.data?.length ? (
                                    <div className="flex items-center justify-center min-h-[400px]">
                                        <span className="text-gray-500 font-medium text-lg">
                                            Aucun Client PRO trouvé
                                        </span>
                                    </div>
                                ) : (
                                    <table className="min-w-full divide-y divide-gray-300">
                                        <thead className="bg-[#b269ae]">
                                            <tr>
                                                <th className="py-3.5 pl-4 pr-3 text-left text-sm font-normal text-gray-100 sm:pl-6">Raison sociale </th>
                                                <th className="px-3 py-3.5 text-left text-sm font-normal text-gray-100">Nom et Prenom du dirigeant</th>
                                                <th className="px-3 py-3.5 text-left text-sm font-normal text-gray-100">Pays </th>
                                                <th className="px-3 py-3.5 text-left text-sm font-normal text-gray-100">Ville</th>
                                                <th className="px-3 py-3.5 text-left text-sm font-normal text-gray-100">Adresse mail du dirigeant </th>
                                                <th className="px-3 py-3.5 text-left text-sm font-normal text-gray-100">Téléphone du dirigeant </th>
                                                <th className="px-3 py-3.5 text-left text-sm font-normal text-gray-100">Status</th>
                                                <th className="px-3 py-3.5 text-left text-sm font-normal text-gray-100">Abonnement</th>
                                                <th className="relative py-3.5 pl-3 pr-4 sm:pr-6"></th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200 bg-white">
                                            {clients.data.map((item) => (
                                                <tr key={item?.email}>
                                                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                                        {item?.company_name}
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                        {item?.first_name}{" "}{item?.last_name}
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                        {item?.country}
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                        {item?.city}
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                        {item?.email}
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                        {item.phone}
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                        <Badge status={item.status} type="clients" />
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                      {item?.subscription ? item?.subscription.label : "-" }
                                                    </td>
                                                    <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6 flex items-center justify-end gap-1">
                                                        {isArchived ? (
                                                            <button className="text-[#b269ae] hover:text-purple-300">
                                                                <MdOutlineRestorePage size={30} className="text-[#b369ae] hover:cursor-pointer" />
                                                            </button>
                                                        ) : (
                                                            <>

                                                                <button
                                                                    onClick={() => handleStatusChange(item)}
                                                                    className="flex items-center justify-center px-3 py-1 rounded-full bg-[#b269ae]/20 border border-[#b269ae] text-[#b269ae] font-semibold transition-all duration-300 mr-3 disabled:cursor-not-allowed disabled:bg-gray-600/10 disabled:text-gray-600/40 disabled:border-gray-600/40"
                                                                    title="Gérer le statut"
                                                                >
                                                                    <MdOutlinePublishedWithChanges size={22} />
                                                                </button>
                                                                <button
                                                                    onClick={() => handleEditClick(item)}
                                                                    className="text-[#b269ae] hover:text-purple-300 mr-3"
                                                                    title="Modifier les informations"
                                                                    disabled={item.status === STATUS.Disactivated}
                                                                >
                                                                    <FaPen size={17} />
                                                                </button>
                                                            </>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                        </div>
                    </div>
                </div>
            </div>

            <Pagination
                prevPage={handlePrevPage}
                nextPage={handleNextPage}
                totalPages={totalPages}
                setPage={setPage}
            />

            <ClientStatusModal
                open={statusModalOpen}
                setOpen={setStatusModalOpen}
                selectedClient={selectedClientForStatus}
            // updateClientStatus={updateClientStatus}
            />

            <UpdateClientModal
                open={updateModalOpen}
                onClose={() => {
                    setUpdateModalOpen(false);
                    setSelectedClientForUpdate(null);
                }}
                client={selectedClientForUpdate}
                currentStatus={selectedClientForUpdate?.status}
                onUpdate={handleUpdateSuccess}
            />
            <CreateClientPROModal open={createClientProModalOpen} setOpen={setCreateClientProModalOpen} />

        </div>
    );
}